import { createContext } from "react";

import { SessionSurveyContextType } from "@/modules/session-survey/types/SessionSurveyContextType";

export const SessionSurveyContext =
  createContext<SessionSurveyContextType | null>(null);
